export default {
  subTitle: 'Overview',
  pageTitle: 'Events',

  createWorkshop: 'Create event',
  newBookingsToday: 'New registrations today'
}